/* @flow */
import React, { useContext } from "react";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import { AppBarButtonWrapper } from "nx-components/AppBar";
import Button from "nx-components/Button";
import Theme from "nx-components/Theme";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  customActionTitle?: ?string,
  onEdit?: ?() => void,
  onDelete?: ?() => void,
  onSave?: ?() => void,
  onSaveAs?: ?() => void,
  onLoad?: ?() => void,
  onCustomAction?: ?() => mixed,
  colors: ColorSet,
};

const AppBarButtons = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.AppBarButtons;
  const {
    customActionTitle,
    onEdit,
    onDelete,
    onSave,
    onSaveAs,
    onLoad,
    onCustomAction,
    colors,
  } = props;

  const styles = {
    button: {
      marginRight: Theme.Padding.APP_BAR_BUTTON,
      marginLeft: Theme.Padding.APP_BAR_BUTTON,
      // currently Button overrides custom styles with a theme if present, so we can't use the
      // "reverse" theme and make the text red at the same time (for the delete button)
      backgroundColor: colors.PRIMARY_TEXT,
      color: colors.PRIMARY,
    },
  };

  return (
    <AppBarButtonWrapper>
      {onCustomAction && (
        <Button onTap={onCustomAction} style={styles.button}>
          {customActionTitle}
        </Button>
      )}
      {onDelete && (
        <Button
          onTap={onDelete}
          style={{ ...styles.button, color: colors.RED }}
        >
          {language.deleteButton}
        </Button>
      )}
      {onEdit && (
        <Button onTap={onEdit} style={styles.button}>
          {language.editButton}
        </Button>
      )}
      {onSave && (
        <Button onTap={onSave} style={styles.button}>
          {language.saveButton}
        </Button>
      )}
      {onSaveAs && (
        <Button onTap={onSaveAs} style={styles.button}>
          {language.saveAsButton}
        </Button>
      )}
      {onLoad && (
        <Button onTap={onLoad} style={styles.button}>
          {language.loadButton}
        </Button>
      )}
    </AppBarButtonWrapper>
  );
};

export default withColorsProvider(AppBarButtons);



// WEBPACK FOOTER //
// ./src/components/TopBar/AppBarButtons.jsx